import mapboxgl from 'mapbox-gl';
import { latLngToLngLat } from './utils';

export const getBoundsFromLatLng = (latLng) => {
  const lngLat = latLngToLngLat(latLng);
  const bounds = new mapboxgl.LngLatBounds();

  lngLat.map((p) => {
    const point = new mapboxgl.LngLat(p[0], p[1]);
    return bounds.extend(point);
  });

  return bounds;
};

export default {
  getBoundsFromLatLng
};
